/* istanbul ignore file */
export * from './CategoryPageCmsContentOnly';
